﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

const uri = (): string => {
    const uri = "api/sopnl/v1/selfservice/register";

    return uri;
};

const method = "POST";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

export type PostSelfServiceRegistrationResponseSuccess = {
    HasError: false;
    AllowAppRegistration: boolean;
    AllowManualRegistration: boolean;

    AgreementLink: string;
    AgreementText: string;

    AppRegistrationRequestId?: string;
    AppRegistrationAppUrl?: string;

    IsRegistered: boolean;

    Tenants: SelfServiceRegistrationTenant[];
};

export type PostSelfServiceRegistrationResponseFailure = {
    HasError: true;

    IsRegistered: boolean;

    Errors: PostSelfServiceRegistrationResponseError[];
};

export interface PostSelfServiceRegistrationResponseError {
    Field: string;
    Message: string;
    MessageArguments: string[];
}

export type PostSelfServiceRegistrationResponse =
    | PostSelfServiceRegistrationResponseSuccess
    | PostSelfServiceRegistrationResponseFailure;

export interface SelfServiceRegistrationTenant {
    TenantUid: string;
    TenantName: string;
}

export interface PostSelfServiceRegistrationRequest {
    Locale: string;

    Email: string;
    Password: string;
    AccessKey: string;
    AccessCode: string;

    Claims: SelfServiceRegistrationClaim[];

    AppRegistrationRequestId?: string;

    TenantUid?: string;

    IsPartial: boolean;
}

export interface SelfServiceRegistrationClaim {
    Type: string;
    Value: string;
}

export interface PostSelfServiceRegistrationProps extends api.ApiHookBaseProps<
    PostSelfServiceRegistrationRequest,
    PostSelfServiceRegistrationResponse,
    unknown
> {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function usePostSelfServiceRegistration(
    props: PostSelfServiceRegistrationProps
): [boolean, (data: PostSelfServiceRegistrationRequest) => Promise<unknown>] {
    const apiParams: api.ApiHookProps<
        PostSelfServiceRegistrationRequest,
        PostSelfServiceRegistrationResponse,
        unknown
    > = {
        ...props,
        uri: uri(),
        method: method,
    };

    const [loading, invoker] = api.useApi<
        PostSelfServiceRegistrationRequest,
        unknown,
        unknown
    >(apiParams);
    return [
        loading,
        (data: PostSelfServiceRegistrationRequest) =>
            invoker(apiParams.uri, data),
    ];
}
